import React, {useEffect, useState} from "react";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import TableFunction from "../../../../components/table/TableFunction";

/**
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @component
 * @param {Object} props - Component properties.
 * @returns {JSX.Element} The rendered TotalAccessService component.
 */
export const TotalAccessApp =  ({data}) =>{

    const [tableId, setTableId] = useState("tbl_ta_devices_access");
    const [searchId, setSearchId] = useState("txt_ta_devices_access");
    const [devices, setDevices] = useState([]);

    useEffect(() => {
        if (data && data?.accessDeviceProjection) {
            const newDevices = [
                {
                    name: 'mantra_mfstab_ii',
                    count: data?.accessDeviceProjection.noMantra
                },
                {
                    name: 'pda_caribe_pl50l',
                    count: data?.accessDeviceProjection.noPda
                },
                {
                    name: 'telpo_tps_450',
                    count: data?.accessDeviceProjection.noTelpo450
                },
                {
                    name: 'telpo_tps_980',
                    count: data?.accessDeviceProjection.noTelpo980
                },
                {
                    name: 'telpo_f6',
                    count: data?.accessDeviceProjection.noTelpoF6
                },
                {
                    name: 'telpo_f6t',
                    count: data?.accessDeviceProjection.noTelpoF6t
                },
                {
                    name: 'telpo_k5',
                    count: data?.accessDeviceProjection.noTelpoK5
                },
                {
                    name: 'telpo_f10',
                    count: data?.accessDeviceProjection.noTelpoF10
                }, {
                    name: 'telpo_k10',
                    count: data?.accessDeviceProjection.noTelpoK10
                },
            ];
            setDevices(newDevices);
        }
    }, [data]);

    const CalculateTotalDevice = (item) => {
        const totalDevice =
            item?.accessDeviceProjection?.noMantra +
            item?.accessDeviceProjection?.noPda +
            item?.accessDeviceProjection?.noTelpo450 +
            item?.accessDeviceProjection?.noTelpo980 +
            item?.accessDeviceProjection?.noTelpoF6 +
            item?.accessDeviceProjection?.noTelpoF6t +
            item?.accessDeviceProjection?.noTelpoK5 +
            item?.accessDeviceProjection?.noTelpoK10 +
            item?.accessDeviceProjection?.noTelpoF10;
        return totalDevice;
    };

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={50} classes="first_head">{t('device')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('Total')}{' '}{CalculateTotalDevice(data)}</CustomTh>,
        ];
    }

    const getTbody = () => {
        if (!data || data?.length === 0) return {
            body: [],
            data: []
        };

        let body = devices?.map((item, index) => {
                return (
                    <>
                        <CustomTd tableId={tableId} tooltip={t(item?.name)} fixed={true} left={50} classes={'first-column'}>
                            {t(item?.name)}
                        </CustomTd>
                        <CustomTd tableId={tableId}>
                            {item?.count}
                        </CustomTd>
                    </>
                );
            });

        return {
            body: body,
            data: devices
        }
    };

    const {t, thead, tbody} = TableFunction({
        fixedPagination:false,
        data:{
            content:devices,
            totalElements:data?.devices?.length
        },
        getThead,
        getTbody,
        labelRowsPerPage:"devices_per_page"
    });

    return {
        tableId, searchId, thead, tbody
    };

}
